export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'PAGES': 'Pages',
            'DASHBOARD': {
                'TITLE': 'Dashboard',
                'BADGE': '500'
            },
            'CALENDAR': {
                'TITLE': 'Calendar',
                'BADGE': '50'
            },
            'LEADS': {
                'TITLE': 'Leads',
                'BADGE': '50'
            },
            'LEADS_INDIVIDUAL': {
                'TITLE': 'Individuals',
                'BADGE': '50'
            },
            'LEADS_LEGAL': {
                'TITLE': 'Legals',
                'BADGE': '50'
            },
            'CLIENTS': {
                'TITLE': 'Clients',
                'BADGE': '333'
            },
            'CLIENTS_INDIVIDUAL': {
                'TITLE': 'Individuals',
                'BADGE': '333'
            },
            'CLIENTS_LEGAL': {
                'TITLE': 'Legals',
                'BADGE': '333'
            },
            'PROFILE': {
                'TITLE': 'Profile',
                'BADGE': '444'
            },
            'ADDRESS_BOOK': {
                'TITLE': 'Address book',
                'BADGE': '777'
            },
            'CUSTOM_FUNCTIONS': {
                'TITLE': 'Settings',
            },
            'CUSTOM_SETTINGS': {
                'TITLE': 'Appearance settings',
            },
            'SETTINGS': {
                'TITLE': 'Common settings',
            },
            'MAIL': {
                'TITLE': 'Mailbox',
            },
            'TICKETS': {
                'TITLE': 'Tickets',
            },
            'COPYTRADING': {
                'TITLE': 'Copytrading',
            },
            'PARTNERSHIP': {
                'TITLE': 'Partnership',
            },
            'PAYMENTS_RATES': {
                'TITLE': 'Payments rates'
            },
            'IMPORT': {
                'TITLE': 'Import'
            },
            'EXPORT': {
                'TITLE': 'Export'
            },
            'CONTACTS': {
                'TITLE': 'Contacts'
            },
            'EMAILS': {
                'TITLE': 'Emails',
                'BADGE': ''
            },
            'EMAIL_RULES': {
                'TITLE': 'Bulk emails',
                'BADGE': ''
            },
            'EMAIL_TEMPLATES': {
                'TITLE': 'Email templates',
                'BADGE': ''
            },
            'USER_SELECTIONS': {
                'TITLE': 'User selections',
                'BADGE': ''
            },
            'BULK_EMAILS': {
                'TITLE': 'Bulk emails',
                'BADGE': ''
            }
        },
        'DIALOGS': {
            'FROM': 'From',
            'TO': 'To',
            'SUBORDINATES': 'Subordinates',
            'ALL_SUBORDINATES': 'All subordinates',
            'REPORT': 'Report',
            'TYPE': 'Type',
            'CANCEL': 'Cancel',
            'GET_REPORT': 'Get report',
            'SEARCH': 'Search',
            'CLIENTS': 'Clients',
            'LEADS': 'Leads',
            'IMPORT_LEADS': 'Import leads',
            'ATTACH_BINARY_OR': 'Attach binary by dropping them here or',
            'SELECTING_ONE': 'selecting one',
            'UPLOAD': 'Upload',
            'SUCCESS_IMPORT': '{{success}} of {{total}} were imported, {{exists}} already exist',
            'IMPORT_ERR': 'Invalid file format',
            'EXPORT_CLIENTS': 'Export Clients',
            'CLIENTS_NP': 'Individuals and entrepreneurs',
            'CLIENTS_LP': 'Legal persons',
            'EXPORT_ERR': 'No clients to export',
            'DOWNLOAD_TEMPLATE': 'Download import template',
            'DOWNLOAD_COUTRY_LIST': 'Download country list',
            'CONTACTS': 'Contacts'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/navigation/i18n/en.ts